function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import { decrypt, getKeyFromPem } from 'helpers/crypto';
import { getSlug } from 'helpers/urlTools';
import * as constants from './constants';
export const groupNotificationsByTimestamp = (notifications)=>{
    if (!notifications || !notifications.length) {
        return {
            today: [],
            yesterday: [],
            thisWeek: [],
            older: []
        };
    }
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startOfYesterday = new Date(startOfToday);
    startOfYesterday.setDate(startOfToday.getDate() - 1);
    const sevenDaysAgo = new Date(startOfToday);
    sevenDaysAgo.setDate(startOfToday.getDate() - 6);
    return notifications.reduce((groups, item)=>{
        const date = new Date(item.timestamp * 1000);
        if (date >= startOfToday) {
            groups.today.push(item);
        } else if (date >= startOfYesterday && date < startOfToday) {
            groups.yesterday.push(item);
        } else if (date >= sevenDaysAgo) {
            groups.thisWeek.push(item);
        } else {
            groups.older.push(item);
        }
        return groups;
    }, {
        today: [],
        yesterday: [],
        thisWeek: [],
        older: []
    });
};
export const transformNotificationsRecord = (notification, ctx)=>{
    const { hcpClinicMemberships, enrollingSharingRequests, accountPrvKey, activeOrganizationUID, notificationResourcesToLinks } = ctx;
    const variables = notification.variables || {};
    const { clinicName, patientFirstName, patientLastName, patientProfileId, localPatientProfileId, inviteeFirstname, inviteeFirstName, inviteeLastname, inviteeLastName, sharingRequestId, clinicId, encryptedClinicPatientProfileId, encryptedLocalPatientProfileId } = variables;
    let patientId = variables.patientProfileId || variables.localPatientProfileId;
    let patientSlug;
    let clinicSlug;
    const linksToRender = notificationResourcesToLinks[notification.resourceKey];
    forEach(linksToRender, (linkToRender)=>{
        switch(linkToRender){
            case constants.NOTIFICATION_LINKS.FAMILY_MEMBER:
                {
                    patientSlug = getSlug(`${inviteeFirstname || inviteeFirstName} ${inviteeLastname || inviteeLastName}`);
                    break;
                }
            case constants.NOTIFICATION_LINKS.PATIENT_PROFILE:
                {
                    clinicSlug = getSlug(clinicName);
                    patientSlug = getSlug(`${patientFirstName || inviteeFirstname || inviteeFirstName} ${patientLastName || inviteeLastname || inviteeLastName}`);
                    patientId = patientProfileId || localPatientProfileId;
                    if (sharingRequestId) {
                        const sharingRequest = find(enrollingSharingRequests, {
                            sharingRequestId: +sharingRequestId,
                            sharingStatus: 'Enrolling'
                        });
                        if (sharingRequest) {
                            patientId = `esr-${sharingRequestId}`;
                        }
                    }
                    // backward compatibility until migration of encyptedPatientId into patientId will be over
                    if (!patientId && accountPrvKey) {
                        const clinicMembership = find(hcpClinicMemberships, {
                            clinicId: +clinicId
                        });
                        if (clinicMembership) {
                            const { encryptedPrivateKey, encryptedPassphrase } = clinicMembership;
                            const clinicKeyPassphrase = decrypt(encryptedPassphrase, accountPrvKey);
                            const clinicKey = getKeyFromPem(encryptedPrivateKey, clinicKeyPassphrase);
                            patientId = decrypt(encryptedClinicPatientProfileId || encryptedLocalPatientProfileId, clinicKey);
                        }
                    }
                    break;
                }
            case constants.NOTIFICATION_LINKS.CLINIC:
                {
                    clinicSlug = getSlug(clinicName);
                    break;
                }
            case constants.NOTIFICATION_LINKS.VISIT_NOTES:
                {
                    clinicSlug = getSlug(clinicName);
                    patientSlug = getSlug(`${patientFirstName} ${patientLastName}`);
                    patientId = patientProfileId || localPatientProfileId;
                    break;
                }
            default:
                {
                    break;
                }
        }
    });
    return _object_spread_props(_object_spread({}, notification), {
        variables: _object_spread_props(_object_spread({}, variables), {
            patientId,
            clinicSlug,
            patientSlug,
            organizationUID: activeOrganizationUID
        })
    });
};
